var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99988 12C3.99988 14.1217 4.84273 16.1566 6.34302 17.6569C7.84331 19.1571 9.87815 20 11.9999 20C14.1216 20 16.1564 19.1571 17.6567 17.6569C19.157 16.1566 19.9999 14.1217 19.9999 12C19.9999 9.87827 19.157 7.84344 17.6567 6.34315C16.1564 4.84285 14.1216 4 11.9999 4C9.87815 4 7.84331 4.84285 6.34302 6.34315C4.84273 7.84344 3.99988 9.87827 3.99988 12V12Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47344 13.5996C7.38813 13.5996 7.30406 13.6201 7.22829 13.6593C7.15253 13.6986 7.08728 13.7554 7.03803 13.8251C6.98878 13.8947 6.95696 13.9752 6.94524 14.0597C6.93352 14.1442 6.94225 14.2303 6.97069 14.3107C7.33775 15.3515 8.01864 16.2528 8.91949 16.8903C9.82034 17.5278 10.8968 17.8702 12.0004 17.8702C13.104 17.8702 14.1804 17.5278 15.0813 16.8903C15.9821 16.2528 16.663 15.3515 17.0301 14.3107C17.0585 14.2303 17.0672 14.1442 17.0555 14.0597C17.0438 13.9752 17.012 13.8947 16.9627 13.8251C16.9135 13.7554 16.8482 13.6986 16.7725 13.6593C16.6967 13.6201 16.6126 13.5996 16.5273 13.5996H7.47344Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6172 10.9332C16.507 10.6212 16.3027 10.351 16.0325 10.1599C15.7623 9.96883 15.4395 9.86621 15.1086 9.86621C14.7777 9.86621 14.4549 9.96883 14.1847 10.1599C13.9145 10.351 13.7102 10.6212 13.6 10.9332",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3997 10.9332C10.2895 10.6212 10.0852 10.351 9.81499 10.1599C9.5448 9.96883 9.22201 9.86621 8.89107 9.86621C8.56013 9.86621 8.23734 9.96883 7.96715 10.1599C7.69697 10.351 7.49268 10.6212 7.38245 10.9332",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji);
export default __webpack_public_path__ + "static/media/Emoji.4e0606815bcb2fecfc1aaa881e00cc37.svg";
export { ForwardRef as ReactComponent };